import CustomerAddActivity from "./CustomerAddActivity";
import CustomerAddActivityPopup from "./CustomerAddActivityPopup";

export default CustomerAddActivity;

export { CustomerAddActivityPopup };
